import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

const toUrl = (url: string, base?: string) => {
  try {
    return new URL(url, base || window.location.origin);
  } catch {
    return null;
  }
};

const backendOrigin = toUrl(backendUrl)?.origin;

const isGeoTrackingApiUrl = (url: string, base?: string) => {
  const parsed = toUrl(url, base);
  if (!parsed) return false;

  const isBackendRequest =
    parsed.origin === backendOrigin || parsed.origin === window.location.origin;
  if (!isBackendRequest) return false;

  return (
    parsed.pathname.startsWith("/api/") &&
    !parsed.pathname.startsWith("/api/v1/") &&
    !parsed.pathname.startsWith("/api/geop/")
  );
};

axios.interceptors.request.use((config) => {
  const url = config.url || "";
  if (isGeoTrackingApiUrl(url, config.baseURL)) {
    config.withCredentials = true;
  }
  return config;
});

const nativeFetch = window.fetch.bind(window);

window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  const requestUrl =
    typeof input === "string"
      ? input
      : input instanceof URL
        ? input.href
        : input.url;

  if (isGeoTrackingApiUrl(requestUrl) && init?.credentials === undefined) {
    return nativeFetch(input, { ...init, credentials: "include" });
  }

  return nativeFetch(input, init);
};
